import { useQuery } from "@tanstack/react-query";

import apiClient from "@/lib/api/client";

export interface TeamLeadRequestCountsResponse {
  counts: {
    allRequests: {
      awaitingReply: number;
      inQueue: number;
      others: number;
      processing: number;
      total: number;
    };
    assignedToMe: {
      awaitingReply: number;
      inQueue: number;
      others: number;
      processing: number;
      total: number;
    };
    teamRequests: {
      total: number;
    };
    unassignedRequests: {
      awaitingReply: number;
      inQueue: number;
      others: number;
      processing: number;
      total: number;
    };
  };
}

interface UseTeamLeadRequestCountsOptions {
  enabled?: boolean;
  search?: string;
  userId?: string;
}

export function useTeamLeadRequestCounts({
  enabled = true,
  search = "",
  userId,
}: UseTeamLeadRequestCountsOptions = {}) {
  return useQuery({
    enabled,
    gcTime: 10 * 60 * 1000, // 10 minutes
    queryFn: async () => {
      const params = new URLSearchParams();

      if (search) {
        params.append("search", search);
      }

      if (userId) {
        params.append("forUserId", userId);
      }

      const queryString = params.toString();
      const baseUrl = "/requests/counts/team-lead";
      const url = queryString ? baseUrl + "?" + queryString : baseUrl;

      return await apiClient
        .url(url)
        .get()
        .json<TeamLeadRequestCountsResponse>();
    },
    queryKey: ["teamLeadCounts", search, userId ?? "self"],
    staleTime: 30_000, // 30 seconds
  });
}
